import React__default, { useContext } from 'react';
import classNames from 'classnames';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import { ReactComponent as SvgCloseCircle } from '../../icons/CloseCircle.svg.js';
import { ReactComponent as SvgLimitReached } from '../../icons/LimitReached.svg.js';
import { AppContext } from '../../app-context.js';
import AppBtn from '../app-btn/AppBtn.js';
import Styles from './DailyLimitReachedModal.module.scss.js';
import A from '../app-anchor/A.js';
import { PLAYSTORE_URLS } from '../../constants/link.js';
import { useTranslation } from 'react-i18next';
import { getTransporterFigure } from '../../methods/getTransporterFigure.js';

const DailyLimit = ({ isVisible, handleLimitToggle, t }) => {
    const { t: _t } = useTranslation(["transporters"]);
    t = t || _t;
    const { isMobile } = useContext(AppContext);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Modal, { isOpen: isVisible, centered: true, keyboard: true, unmountOnClose: true, toggle: handleLimitToggle, className: classNames(isMobile ? Styles.mobile : Styles.desktop), contentClassName: classNames(Styles.content) },
            React__default.createElement(ModalHeader, { toggle: handleLimitToggle, close: React__default.createElement(SvgCloseCircle, { onClick: handleLimitToggle, style: { cursor: "pointer" } }), className: classNames(Styles.header) }),
            React__default.createElement(ModalBody, { className: classNames(Styles.body) },
                React__default.createElement("div", { className: Styles.iconContainer },
                    React__default.createElement(SvgLimitReached, { height: isMobile ? "50px" : "60px", width: isMobile ? "53px" : "74.28px" })),
                React__default.createElement("div", { className: classNames(Styles.dailyLimitHeading, isMobile ? Styles.dailyLimitHeading__mob : Styles.dailyLimitHeading__web) }, t("daily_limit_reached.limit_reached")),
                React__default.createElement("div", { className: classNames(Styles.text, isMobile ? Styles.text__mob : Styles.text__web) }, t("daily_limit_reached.download_app", { transporterFigure: getTransporterFigure() })),
                React__default.createElement(A, { openInNewTab: true, href: PLAYSTORE_URLS.transporterSearchPage, title: t("daily_limit_reached.get_contact_details_cta") },
                    React__default.createElement(AppBtn, { width: "100%", isMobile: isMobile, type: "primary", onClick: () => {
                            handleLimitToggle();
                        }, className: classNames(isMobile ? Styles.ButtonStyle__mob : Styles.ButtonStyle__web) }, t("daily_limit_reached.get_contact_details_cta")))))));
};

export { DailyLimit as default };
//# sourceMappingURL=DailyLimitReachedWarning.js.map
